.scheduleRow {
  display: flex;
  gap: 16px;
  width: 100%;

  & > * {
    flex: 1;
    min-width: 0;
  }
}

// The delivery time label includes its time range, which does not fit in a
// column shared with the other selects.
.scheduleRowWithDeliveryRange {
  flex-wrap: wrap;

  & > :last-child {
    flex: 1 1 100%;
  }
}
